enum Actions {
  // action types
  ADD_BODY_CLASSNAME = "addBodyClassName",
  REMOVE_BODY_CLASSNAME = "removeBodyClassName",
  ADD_BODY_ATTRIBUTE = "addBodyAttribute",
  REMOVE_BODY_ATTRIBUTE = "removeBodyAttribute",
  ADD_CLASSNAME = "addClassName",
  VERIFY_AUTH = "verifyAuth",
  LOGIN = "Login",
  LOGIN_ATTEMPTS = "LoginAttempts",
  COMLOGIN = "LoginByCompany",
  LOGOUT = "Logout",
  REGISTER = "register",
  UPDATE_USER = "updateUser",
  FORGOT_PASSWORD = "forgotPassword",
  SET_BREADCRUMB_ACTION = "setBreadcrumbAction",
  ADD_PERMS = "addPerms",
  PURGE = "purge",
}

enum Mutations {
  // mutation types
  SET_CLASSNAME_BY_POSITION = "appendBreadcrumb",
  PURGE_AUTH = "purgeAuth",
  SET_AUTH = "setAuth",
  SET_USER = "setUser",
  SET_PASSWORD = "setPassword",
  SET_ERROR = "setError",
  SET_BREADCRUMB_MUTATION = "setBreadcrumbMutation",
  SET_LAYOUT_CONFIG = "setLayoutConfig",
  RESET_LAYOUT_CONFIG = "resetLayoutConfig",
  OVERRIDE_LAYOUT_CONFIG = "overrideLayoutConfig",
  OVERRIDE_PAGE_LAYOUT_CONFIG = "overridePageLayoutConfig",
  SET_PERMS = "setPerms",
}

enum Users {
  findPageUser = "findPageUser",
  saveUser = "saveUser",
  blockUser = "blockUser",
  deleteUser = "deleteUser",
  changePasswordSelf = "changePasswordSelf",
  changePassword = "changePassword",
  findUserByName = "findUserByName",
  findAllUser = "findAllUser",
  userDownload = "userDownload",
  findUserPermissions = "findUserPermissions",
  getUserInfo = "getUserInfo"
}
enum Menu {
  addMenu = "addMenu",
  viewMenu = "viewMenu",
  editMenu = "editMenu",
  deleteMenu = "deleteMenu",
  findMenuTree = "findMenuTree",
  findMenu = "findMenu",
  findNavTree = "findNavTree",
}

enum Roles {
  saveRole = "saveRole",
  deleteRole = "deleteRole",
  findPageRole = "findPageRole",
  findAllRole = "findAllRole",
  findRoleMenu = "findRoleMenu",
  saveRoleMenu = "saveRoleMenu",
  findRole = "findRole",
}

//bhtt
enum Violation {
  findViolation = 'findViolation',
  syncViolation = 'syncViolation',
}
enum Certificate {
  findPageCertificate = "findPageCertificate",
  createCertificate = "createCertificate",
  deleteCertificate = "deleteCertificate",
  deleteFileScan = "deleteFileScan",
  editCertificate = "editCertificate",
}
enum Branches {
  findPageBranch = "findPageBranch",
  insertBranch = "insertBranch",
  updateBranch = "updateBranch",
  deleteBranch = "deleteBranch",
}
enum Distributor {
  findPageDistributor = "findPageDistributor",
  insertDistributor = "insertDistributor",
  updateDistributor = "updateDistributor",
  deleteDistributor = "deleteDistributor",
}
enum Payment {
  findPagePaymentMethod = "findPagePaymentMethod",
  insertPaymentMethod = "insertPaymentMethod",
  updatePaymentMethod = "updatePaymentMethod",
  deletePaymentMethod = "deletePaymentMethod",
}
enum Supplier {
  findPageSupplier = "findPageSupplier",
  insertSupplier = "insertSupplier",
  updateSupplier = "updateSupplier",
  deleteSupplier = "deleteSupplier",
}
enum Transportation {
  getShippingMethod = "getShippingMethod",
  saveShippingMethod = "saveShippingMethod",
}

enum Supply {
  findPageSupply = "findPageSupply",
  insertSupplyNew = "insertSupplyNew",
  updateSupplyNew = "updateSupplyNew",
  deleteSupplyNew = "deleteSupplyNew",
  SupplyImageAdded = "SupplyImageAdded",
  SupplyImageRemoved = "SupplyImageRemoved",
}
enum Common {
  getCategoryList = "getCategoryList",
  uploadImg = "uploadImg",
}
enum Log {
  findPageLog = "findPageLog"
}
enum Shop {
  findPageShop = "findPageShop",
  saveShop = "saveShop",
  deleteShopRecord = "deleteShopRecord",
  showShop = "showShop",
  findShopInfo = "findShopInfo",
  updateShopDescription = "updateShopDescription",
  syncShop = "syncShop",
  downloadShopRankingReport = "downloadShopRankingReport",
}
enum Bank {
  showBank = "showBank"
}
enum Product {
  findPageProduct = "findPageProduct",
  findProductById = "findProductById",
  saveProduct = "saveProduct",
  deleteProductRecord = "deleteProductRecord",
  showProduct = "showProduct",
  dataSyncProduct = "dataSyncProduct",
  syncProductRating = "syncProductRating",
  findPageProductRating = "findPageProductRating",
  downloadProductRankingReport = "downloadProductRankingReport",
}
enum Order {
  findPageOrder = "findPageOrder",
  confirmOrder = "confirmOrder",
  cancelOrder = "cancelOrder",
  deleteOrderLine = "deleteOrderLine",
  dataSyncOrder = "dataSyncOrder",
}
enum Dashboard {
  getTotalOrderByLastMonth = "getTotalOrderByLastMonth",
  getSentOrders = "getSentOrders",
  getOrdersByLastMonth = "getOrdersByLastMonth",
  getAmountTotalByProduct = "getAmountTotalByProduct",
}
enum Inventory {
  newImport = "newImport",
  updateImport = "updateImport",
  getImports = "getImports",
  findImportById = "findImportById",
  confirmImport = "confirmImport",
  deleteImport = "deleteImport",
  newExport = "newExport",
  updateExport = "updateExport",
  getExports = "getExports",
  findExportById = "findExportById",
  confirmExport = "confirmExport",
  deleteExport = "deleteExport",
  inventoryReport = "inventoryReport",
  getHistorys = "getHistorys",
}
enum Report {
  partnerRevenue = "partnerRevenue"
}


//mini-app
enum Banners {
  findBannersById = "findBannersById",
  updateBanners = "updateBanners",
  deleteBannersById = "deleteBannersById",
  saveBanners = "saveBanners",
  findPageBanners = "findPageBanners",
  uploadBannerImage = "uploadBannerImage"
}

enum Broadcasts {
  findBroadcastsById = "findBroadcastsById",
  updateBroadcasts = "updateBroadcasts",
  deleteBroadcastsById = "deleteBroadcastsById",
  saveBroadcasts = "saveBroadcasts",
  findPageBroadcasts = "findPageBroadcasts",
  findPageBroadcastsByType = "findPageBroadcastsByType",
}

enum Cameras {
  findCamerasById = "findCamerasById",
  updateCameras = "updateCameras",
  deleteCamerasById = "deleteCamerasById",
  saveCameras = "saveCameras",
  findPageCamerasByType = "findPageCamerasByType",
  findPageCamera = "findPageCamera",
}

enum Feedbacks {
  getAllFeedbackByFilter = "getAllFeedbackByFilter",
  getFeedbackById = "getFeedbackById",
  getResponseById = "getResponseById",
  getAllResponseByFeedbackId = "getAllResponseByFeedbackId",
  insertFeedback = "insertFeedback",
  insertResponsesByFeedbackId = "insertResponsesByFeedbackId",
  updateResponseByFeedbackId = "updateResponseByFeedbackId",
  updateFeedbackById = "updateFeedbackById",
  deleteFeedbackById = "deleteFeedbackById",
  deleteResponseByFeedbackId = "deleteResponseByFeedbackId",
  getFeedBackType = "getFeedBackType",
  listFeedBack = "listFeedBack",
  feedbackHistory = "feedbackHistory",
}

enum Hotlines {
  findHotlinesById = "findHotlinesById",
  updateHotlines = "updateHotlines",
  deleteHotlinesById = "deleteHotlinesById",
  saveHotlines = "saveHotlines",
  findPageHotlines = "findPageHotlines",
  findPageHotlinesByType = "findPageHotlinesByType",
}

enum Travels {
  findTravelsById = "findTravelsById",
  updateTravels = "updateTravels",
  deleteTravelsById = "deleteTravelsById",
  saveTravels = "saveTravels",
  findPageTravels = "findPageTravels",
}

enum Utilities {
  findUtilitiesById = "findUtilitiesById",
  updateUtilities = "updateUtilities",
  deleteUtilitiesById = "deleteUtilitiesById",
  saveUtilities = "saveUtilities",
  findPageUtilities = "findPageUtilities",
}

enum News {
  showNews = "showNews",
  listNews = "listNews",
  saveNews = "saveNews",
  updateNews = "updateNews",
  deleteNews = "deleteNews",
  uploadNewsBanner = "uploadNewsBanner",
  uploadArticleImage = "news:uploadArticleImage",
  removeArticleImage = "news:removeArticleImage",
}

enum Categories {
  showCategories = "showCategories",
  insertCategories = "insertCategories",
  updateCategories = "updateCategories",
  deleteCategories = "deleteCategories",
  uploadCategoriesIcon = "uploadCategoriesIcon",
  listCategories = "listCategories",
  restoreToDefault = "restoreToDefault",
}

enum Meetings {
  showMeetings = "showMeetings",
  listMeetings = "listMeetings",
  insertMeetings = "insertMeetings",
  updateMeetings = "updateMeetings",
  deleteMeetings = "deleteMeetings",
  listUser = "listUser",
  findMeetingsById = "findMeetingsById",
  findPageMeetings = "findPageMeetings"
}

enum Plantations {
  showPlantations = "showPlantations",
  listPlantations = "listPlantations",
  savePlantations = "savePlantations",
  updatePlantations = "updatePlantations",
  deletePlantations = "deletePlantations",
  uploadPlantationsBanner = "uploadPlantationsBanner",
  uploadPlantationsArticleImage = "uploadPlantationsArticleImage",
  removePlantationsArticleImage = "removePlantationsArticleImage",
}

enum Cautionary {
  findPageCautionary = "findPageCautionary",
  saveCautionary = "saveCautionary",
  deleteCautionary = "deleteCautionary",
  uploadCautionaryBanner = "uploadCautionaryBanner",
  uploadArticleImage = "cautionary:uploadArticleImage",
  removeArticleImage = "cautionary:removeArticleImage",
}

enum Questions {
  findPageQuestions = "findPageQuestions",
  saveQuestions = "saveQuestions",
  deleteQuestions = "deleteQuestions",
}

enum Reporting {
  findPageReporting = "findPageReporting",
  saveReporting = "saveReporting",
  deleteReporting = "deleteReporting",
}

enum Department {
  findPageDepartment = "findPageDepartment",
  saveDepartment = "saveDepartment",
  deleteDepartment = "deleteDepartment",
  listDepartment = "listDepartment",
}

enum Appointment {
  findPageAppointment = "findPageAppointment",
  saveAppointment = "saveAppointment",
  deleteAppointment = "deleteAppointment",
}

enum LawQuestions {
  findPageLawQuestions = "findPageLawQuestions",
  saveLawQuestions = "saveLawQuestions",
  deleteLawQuestions = "deleteLawQuestions",
}

enum LawExams {
  findPageLawExams = "findPageLawExams",
  saveLawExams = "saveLawExams",
  deleteLawExams = "deleteLawExams",
}

enum HistoryQuestions {
  findPageHistoryQuestions = "findPageHistoryQuestions",
  saveHistoryQuestions = "saveHistoryQuestions",
  deleteHistoryQuestions = "deleteHistoryQuestions",
}

enum HistoryExams {
  findPageHistoryExams = "findPageHistoryExams",
  saveHistoryExams = "saveHistoryExams",
  deleteHistoryExams = "deleteHistoryExams",
}

enum Zones {
  findPageZones = "findPageZones",
  saveZones = "saveZones",
  deleteZones = "deleteZones",
  listZones = "listZones",
}

enum Trainning {
  findPageTrainning = "findPageTrainning",
  saveTrainning = "saveTrainning",
  deleteTrainning = "deleteTrainning",
  listTrainning = "listTrainning",
  saveFromFile = "saveFromFile"
}

enum ChatHistory {
  findPageChatHistory = "findPageChatHistory",
  saveChatHistory = "saveChatHistory",
  deleteChatHistory = "deleteChatHistory",
  listChatHistory = "listChatHistory",
}

enum LawType {
  findPageLawType = "findPageLawType",
  saveLawType = "saveLawType",
  deleteLawType = "deleteLawType",
  listLawType = "listLawType",
}

enum SystemConfig {
  showConfig = "showConfig",
  updateConfig = "updateConfig"
}

export {
  Actions,
  Mutations,
  Users,
  Menu,
  Roles,
  //bhtt
  Violation,
  Certificate,
  Branches,
  Distributor,
  Payment,
  Supplier,
  Transportation,
  Supply,
  Common,
  Log,
  Shop,
  Bank,
  Product,
  Order,
  Dashboard,
  Inventory,
  Report,


  //mini-app
  Banners,
  Broadcasts,
  Cameras,
  Feedbacks,
  Hotlines,
  Travels,
  Utilities,
  News,
  Categories,
  Meetings,
  Plantations,

  Cautionary,
  Appointment,
  Questions,
  Reporting,
  Department,
  LawQuestions,
  LawExams,
  HistoryQuestions,
  HistoryExams,
  Zones,
  Trainning,
  ChatHistory,
  LawType,
  SystemConfig
};
